import React from 'react';
import ReactDOM from 'react-dom';
import { getImageUrl } from '../utils/assets';
import './Dialog.css';
import { t } from 'i18next';

interface DialogProps {
  isOpen: boolean;
  title?: string;
  message?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  showCancel?: boolean;
  confirmDisabled?: boolean;
  children?: React.ReactNode;
}

const Dialog: React.FC<DialogProps> = ({
  isOpen,
  title = t('common.hint', '溫馨提示'),
  message,
  confirmText = t('common.confirm', '確認'),
  cancelText = t('common.cancel', '取消'),
  onConfirm,
  onCancel,
  showCancel = true,
  confirmDisabled = false,
  children
}) => {
  // Helper to get image path
  const getImg = (name: string) => `url(${getImageUrl('common/' + name)})`;

  const content = (
    <div 
      className={`cf-dialog-overlay ${isOpen ? 'cf-dialog-visible' : ''}`}
      onClick={onCancel}
    >
      <div 
        className="cf-dialog-container" 
        onClick={(e) => e.stopPropagation()}
      >
        {/* Panel Background */}
        <div 
          className="cf-dialog-panel" 
          style={{ backgroundImage: getImg('cf_dialog_panel.png') }}
        />
        
        {/* Title */}
        <div className="cf-title-text">{title}</div>
        
        {/* Divider */}
        <div 
          className="cf-divider-line" 
          style={{ backgroundImage: getImg('cf_divider_line.png') }}
        />
        
        {/* Message or Custom Content */}
        {children ? (
          children
        ) : (
          <div className="cf-message-text">{message}</div>
        )}
        
        {/* Buttons */}
        <div className="cf-button-container">
          {/* Confirm Button */}
          <div 
            className={`cf-button ${confirmDisabled ? 'disabled' : ''}`}
            style={{ 
              backgroundImage: confirmDisabled 
                ? getImg('cf_button_disabled.png') 
                : getImg('cf_button_primary.png') 
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (!confirmDisabled && onConfirm) onConfirm();
            }}
          >
            <span className="cf-button-text">{confirmText}</span>
          </div>
          
          {/* Cancel Button */}
          {showCancel && (
            <div 
              className="cf-button"
              style={{ backgroundImage: getImg('cf_button_primary.png') }}
              onClick={(e) => {
                e.stopPropagation();
                if (onCancel) onCancel();
              }}
            >
              <span className="cf-button-text">{cancelText}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(content, document.body);
};

export default Dialog;
